import { request } from "./http";

/**
 * 分页查询用户列表
 * @param {{ pageNo?: number, pageSize?: number, keyword?: string }} params
 * @returns {Promise<{code: number, msg: string, data: { pageNo: number, pageSize: number, pageCount: number, total: number, list: Array<object> }}>}
 */
export const getUserList = async ({
  pageNo = 1,
  pageSize = 10,
  keyword = "",
} = {}) => {
  const payload = {
    pageNo,
    pageSize,
  };
  const trimmedKeyword = `${keyword || ""}`.trim();

  if (trimmedKeyword) {
    payload.query = [
      {
        field: "nickName",
        operator: "ilike",
        value: `%${trimmedKeyword}%`,
      },
    ];
  }

  return request.post("/api/v1/compute/user/pageList", payload);
};

/**
 * 新增用户时远程搜索用户名
 * @param {{ fullName?: string }} payload
 * @returns {Promise<{code: number, msg: string, data: Array<{id: string | number, emailAddress: string, fullName: string}>}>}
 */
export const findUser = async ({ fullName = "" } = {}) => {
  return request.post("/api/v1/compute/user/findUser", {
    fullName,
  });
};

/**
 * 新增用户
 * @param {{ nickName: string, email: string, status: "0" | "1" }} payload
 * @returns {Promise<{code: number, msg: string, data: null}>}
 */
export const createUser = async (payload) => {
  return request.post("/api/v1/compute/user/add", payload);
};

/**
 * 修改用户
 * @param {{ id: string, nickName: string, email: string, status: "0" | "1" }} payload
 * @returns {Promise<{code: number, msg: string, data: null}>}
 */
export const updateUser = async (payload) => {
  return request.post("/api/v1/compute/user/update", payload);
};

/**
 * 上传账户头像
 * @param {File} file
 * @returns {Promise<string | {code?: number, msg?: string, data?: string}>}
 */
export const uploadAvatar = async (file) => {
  const formData = new FormData();
  formData.append("anyfile", file);
  return request.post("/api/v1/upload?name=avatar&path=avatar", formData);
};

/**
 * 删除用户
 * @param {string[] | string} ids
 * @returns {Promise<{code: number, msg: string, data: string}>}
 */
export const deleteUsers = async (ids) => {
  const normalizedIds = Array.isArray(ids) ? ids : [ids];
  return request.post("/api/v1/compute/user/delete", {
    ids: normalizedIds,
  });
};
